import { RawDataStore } from './RawDataStore'
import { derived, writable } from 'svelte/store'

const AppStoreState = writable({
  activePodcastID: 0,
  durationIndex:1,
  activeChunkIndex: 0,
})

const createAppStore = () => {

  //Setup the derived store
  const { subscribe } = derived(
    [AppStoreState, RawDataStore],
    ([$AppStoreState, $RawDataStore], set) => {

      //Update the derived store values based upon the stores we're deriving from.
      set({
        podcasts: $RawDataStore ? $RawDataStore.podcasts : undefined, 
        state: $AppStoreState,
      })
    }
  ) 

  const selectPodcastWithID = (id) => {
    AppStoreState.update(state => ({
      ...state, 
      activePodcastID: id
    }) )
    console.debug("Set podcastID to", id)
  }

  const setDurationToIndex = (index) => {
    AppStoreState.update(state => ({
      ...state, 
      durationIndex: index
    }) )
    console.debug("Set durationIndex to", index)
  }

  const setActiveChunkIndex = (index) => {
    AppStoreState.update(state => ({
      ...state, 
      activeChunkIndex: index
    }) )
    console.debug("Set activeChunkIndex to", index)
  }

  //Return a custom store with the derived values AND a method to update the CurrentBandIndex
  return {
    subscribe,
    selectPodcastWithID,
    setDurationToIndex,
    setActiveChunkIndex,
  }
}

export const AppStore = createAppStore()
